export const state = {
    firstFormStep: 1,
    formStep: 1,
    newVso: {
        id: '',
        fields: {}
    },
    projectId: ''
};